<!--suppress HtmlFormInputWithoutLabel -->
<template>
    <base-input>
        <label slot="label">Music On Hold
            <font-awesome-icon :icon="['fal','spinner-third']" spin v-if="isLoading"/>
        </label>
        <select
            :value="musiconhold"
            @change="$emit('change')"
            @input="updateMusiconhold"
            class="form-control"
            v-if="isLoading === false"
            id="musiconholdselect"
            name="musiconhold"
            placeholder="Music On Hold"
            size="small">
            <option class="select-primary"
                    label="No Music On Hold"
                    :value="null" selected="selected">
            </option>
            <option v-for="moh in musiconholds"
                    class="select-primary"
                    :label="moh.name"
                    :key="moh.full_name"
                    :value="moh.full_name">
            </option>
        </select>
    </base-input>
</template>

<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: "MusicOnHoldSelector",
        props: ['value'],

        computed: {
            ...mapFields(`musiconhold`, ['musiconholds']),
            isLoading() {
                return this.$store.getters['musiconhold/isLoading'];
            }
        },
        data() {
            return {
                musiconhold: this.value,
            };
        },
        methods: {
            updateMusiconhold(value) {
                this.musiconhold = value.target.value;
                this.$emit('input', this.musiconhold )
            }
        },
        mounted() {
            if (this.$store.getters['musiconhold/needUpdate']) {
                this.$store.dispatch('musiconhold/loadMusicOnHold');
            }
        },
        watch: {
            value: function (newVal, oldVal) { // watch it
                this.musiconhold = newVal;
            }
        }
    }
</script>

<style scoped>

</style>
